const BUNDLE_FREQUENCIES = ['One time', '1 week', '2 weeks', '4 weeks', '6 weeks', '8 weeks', '12 weeks'];
const CART_SECTIONS = 'cart-items,cart-footer,cart-item-count,cart-live-region';
const LOOP_APP_ID = '5284869';
const BUNDLE_DRAFT_STORAGE_KEY = 'evermoreBundleDraft';
const BUNDLE_BUILDER_PATH = '/pages/shop-online';

const productCache = new Map();
let bundleSummaryStylesInjected = false;

function formatMoney(cents) {
  if (typeof window.formatMoney === 'function' && window.theme?.moneyFormat) {
    return window.formatMoney(cents, window.theme.moneyFormat);
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  }).format(Number(cents || 0) / 100);
}

function canonicalFrequency(value) {
  if (!value) return null;

  const normalized = `${value}`.toLowerCase().trim();
  if (normalized === 'one time' || normalized === 'one-time') return 'One time';
  if (/\bevery\s+week\b/.test(normalized) || normalized === 'week') return '1 week';

  const weekMatch = normalized.match(/\b(\d+)\s*weeks?\b/);
  if (!weekMatch) return null;

  const weekCount = weekMatch[1];
  return BUNDLE_FREQUENCIES.slice(1).find((option) => option.split(' ')[0] === weekCount) || null;
}

function parseBundleConfig(group) {
  try {
    return JSON.parse(group.dataset.bundleConfig || '{}');
  } catch (error) {
    return {
      foodMinimum: 4,
      frequencyOptions: BUNDLE_FREQUENCIES,
      tiers: [
        { threshold: 8, discount: 5, freeShipping: false },
        { threshold: 16, discount: 10, freeShipping: true },
        { threshold: 32, discount: 15, freeShipping: true },
      ],
    };
  }
}

function tierSummary(totalCount, tiers) {
  return [...tiers]
    .sort((left, right) => left.threshold - right.threshold)
    .map((tier) => {
      const classes = ['bundle-cart-card__tier'];
      if (totalCount >= tier.threshold) {
        classes.push('is-active');
      }

      const copy = `${tier.threshold}+ · ${tier.discount}% off`;
      return `<span class="${classes.join(' ')}">${copy}</span>`;
    })
    .join('');
}

function getCounts(lines) {
  return lines.reduce(
    (counts, line) => {
      const quantity = Number(line.dataset.lineQuantity || 0);
      counts.total += quantity;
      if (line.dataset.lineType === 'food') counts.food += quantity;
      if (line.dataset.lineType === 'treat') counts.treat += quantity;
      return counts;
    },
    { total: 0, food: 0, treat: 0 }
  );
}

function imageMarkupForLine(line) {
  const image = line.querySelector('img');
  if (!image) return '';

  return `<img class="bundle-cart-summary__image" src="${escapeHtml(image.currentSrc || image.src)}" alt="${escapeHtml(image.alt || '')}" loading="lazy">`;
}

function escapeHtml(value) {
  return `${value}`
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function summaryMarkupForLines(lines) {
  const imageMarkup = imageMarkupForLine(lines[0]);
  const groupedLines = lines.reduce(
    (groups, line) => {
      const sellingPlan = canonicalFrequency(line.dataset.sellingPlanName);
      const purchaseType = line.dataset.bundlePurchaseType;
      const groupKey = (sellingPlan || purchaseType === 'subscription') ? 'subscription' : 'onetime';
      groups[groupKey].push(line);
      return groups;
    },
    { subscription: [], onetime: [] }
  );
  const renderRows = (groupLines) => groupLines
    .map((line) => {
      const quantity = Number(line.dataset.lineQuantity || 0);
      const title = escapeHtml(line.dataset.lineTitle || 'Bundle item');
      const sellingPlan = canonicalFrequency(line.dataset.sellingPlanName);
      const purchaseType = line.dataset.bundlePurchaseType;
      const originalUnitPrice = Number(line.dataset.lineOriginalUnitPrice || 0);
      const finalUnitPrice = Number(line.dataset.lineFinalUnitPrice || originalUnitPrice);
      const discountTitle = line.dataset.lineDiscountTitle;
      const meta = sellingPlan
        ? `Deliver every ${sellingPlan}`
        : purchaseType === 'one_time'
          ? 'One-time'
          : '';
      const price = originalUnitPrice > finalUnitPrice
        ? `<span class="bundle-cart-summary__price"><s>${formatMoney(originalUnitPrice)}</s><span>${formatMoney(finalUnitPrice)}</span></span>`
        : `<span class="bundle-cart-summary__price">${formatMoney(finalUnitPrice || originalUnitPrice)}</span>`;
      const metaMarkup = [
        discountTitle ? `<span class="bundle-cart-summary__discount">${escapeHtml(discountTitle)}</span>` : '',
        meta ? escapeHtml(meta) : '',
      ].filter(Boolean).join(' ');

      return `
        <div class="bundle-cart-summary__row">
          <span class="bundle-cart-summary__qty">${quantity}×</span>
          <span>
            <span class="bundle-cart-summary__title">${title}</span>
            ${metaMarkup ? `<span class="bundle-cart-summary__meta">${metaMarkup}</span>` : ''}
          </span>
          ${price}
        </div>
      `;
    })
    .join('');
  const groups = [
    groupedLines.subscription.length
      ? `<div class="bundle-cart-summary__group"><p class="bundle-cart-summary__heading">Subscription</p>${renderRows(groupedLines.subscription)}</div>`
      : '',
    groupedLines.onetime.length
      ? `<div class="bundle-cart-summary__group"><p class="bundle-cart-summary__heading">One-time</p>${renderRows(groupedLines.onetime)}</div>`
      : '',
  ].join('');

  return `
    ${imageMarkup}
    <div class="bundle-cart-summary__groups">${groups}</div>
  `;
}

function injectBundleSummaryStyles() {
  if (bundleSummaryStylesInjected || document.getElementById('evermore-bundle-cart-summary-styles')) return;

  const style = document.createElement('style');
  style.id = 'evermore-bundle-cart-summary-styles';
  style.textContent = `
    .bundle-cart-group [data-bundle-group-items],
    .bundle-cart-group [data-bundle-line] {
      display: none !important;
    }

    .bundle-cart-summary {
      display: grid;
      grid-template-columns: 4.75rem minmax(0, 1fr);
      gap: 0.85rem;
      margin-top: 0.9rem;
      padding-top: 0.9rem;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }

    .bundle-cart-summary:empty {
      display: none;
    }

    .bundle-cart-summary__image {
      width: 4.75rem;
      height: 4.75rem;
      border-radius: 0.5rem;
      object-fit: contain;
      background: #fff;
    }

    .bundle-cart-summary__groups {
      display: grid;
      gap: 0.7rem;
      min-width: 0;
    }

    .bundle-cart-summary__group {
      display: grid;
      gap: 0.35rem;
    }

    .bundle-cart-summary__heading {
      margin: 0;
      font-size: 0.72rem;
      line-height: 1.25;
      font-weight: 900;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: rgba(0, 0, 0, 0.58);
    }

    .bundle-cart-summary__row {
      display: grid;
      grid-template-columns: auto minmax(0, 1fr) auto;
      gap: 0.45rem;
      align-items: baseline;
      font-size: 0.88rem;
      line-height: 1.3;
    }

    .bundle-cart-summary__qty {
      font-weight: 900;
      color: rgba(0, 0, 0, 0.68);
    }

    .bundle-cart-summary__title {
      font-weight: 800;
    }

    .bundle-cart-summary__meta {
      display: block;
      margin-top: 0.1rem;
      font-size: 0.76rem;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.58);
    }

    .bundle-cart-summary__discount {
      display: inline-block;
      margin-right: 0.3rem;
      padding: 0.08rem 0.3rem;
      border-radius: 0.25rem;
      background: #8c4399;
      color: #fff;
      font-size: 0.7rem;
      line-height: 1.3;
    }

    .bundle-cart-summary__price {
      display: grid;
      justify-items: end;
      gap: 0.1rem;
      font-weight: 800;
      text-align: right;
      white-space: nowrap;
    }

    .bundle-cart-summary__price s {
      font-size: 0.78rem;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.58);
    }
  `;

  document.head.appendChild(style);
  bundleSummaryStylesInjected = true;
}

function summaryTargetForGroup(group, itemsTarget) {
  let summaryTarget = group.querySelector('[data-bundle-summary]');
  if (summaryTarget) return summaryTarget;

  summaryTarget = document.createElement('div');
  summaryTarget.className = 'bundle-cart-summary';
  summaryTarget.dataset.bundleSummary = '';
  itemsTarget.before(summaryTarget);
  return summaryTarget;
}

function writeBundleEditDraft(lines, frequency) {
  const subscriptionItems = {};
  const oneTimeItems = {};

  lines.forEach((line) => {
    const variantId = line.dataset.variantId;
    const quantity = Number(line.dataset.lineQuantity || 0);
    const purchaseType = line.dataset.bundlePurchaseType;
    const hasSellingPlan = Boolean(canonicalFrequency(line.dataset.sellingPlanName));

    if (variantId && quantity > 0) {
      const targetItems = purchaseType === 'one_time' || (!purchaseType && !hasSellingPlan)
        ? oneTimeItems
        : subscriptionItems;

      targetItems[variantId] = (targetItems[variantId] || 0) + quantity;
    }
  });

  const editKeys = lines
    .map((line) => line.dataset.cartItemKey)
    .filter(Boolean);

  const draft = {
    items: subscriptionItems,
    oneTimeItems,
    frequency: frequency || '',
    edit: {
      keys: editKeys,
    },
  };

  window.sessionStorage.setItem(BUNDLE_DRAFT_STORAGE_KEY, JSON.stringify(draft));
  return draft;
}

function openBundleEditor(lines, frequency) {
  const draft = writeBundleEditDraft(lines, frequency);

  const bundleUrl = new URL(BUNDLE_BUILDER_PATH, window.location.origin);
  bundleUrl.searchParams.set('bundle_edit', '1');
  bundleUrl.searchParams.set('bundle_draft', encodeURIComponent(JSON.stringify(draft)));
  window.location.href = bundleUrl.toString();
}

function bundleLinesForEditButton(editButton) {
  const listRoot = editButton.closest('[data-bundle-lines-root]');
  const group = editButton.closest('[data-bundle-group]');
  if (!listRoot || !group) return [];

  return [...listRoot.querySelectorAll('[data-bundle-line]')].filter((line) => line.closest('[data-bundle-group]') === group);
}

function currentFrequency(lines) {
  const active = new Set(
    lines
      .map((line) => canonicalFrequency(line.dataset.sellingPlanName))
      .filter(Boolean)
  );

  if (!active.size) return 'One time';
  if (active.size === 1) return [...active][0];
  return '';
}

async function fetchProduct(handle) {
  if (!productCache.has(handle)) {
    const promise = fetch(`/products/${handle}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then((response) => response.json());

    productCache.set(handle, promise);
  }

  return productCache.get(handle);
}

async function buildLineSellingPlans(lines) {
  const linePlans = new Map();

  for (const line of lines) {
    const handle = line.dataset.productHandle;
    const variantId = Number(line.dataset.variantId);
    if (!handle || !variantId) continue;

    const product = await fetchProduct(handle);
    const variant = product?.variants?.find((candidate) => Number(candidate.id) === variantId);
    if (!variant) continue;

    const planMap = new Map();
    const allocations = variant.selling_plan_allocations || [];
    const groups = (product.selling_plan_groups || []).filter((group) => `${group.app_id}` === LOOP_APP_ID);

    allocations.forEach((allocation) => {
      const group = groups.find((candidate) => Number(candidate.id) === Number(allocation.selling_plan_group_id));
      if (!group) return;

      const sellingPlan = group?.selling_plans?.find((candidate) => Number(candidate.id) === Number(allocation.selling_plan_id));
      const label = canonicalFrequency(sellingPlan?.options?.[0]?.value || sellingPlan?.name);

      if (label) {
        planMap.set(label, allocation.selling_plan_id);
      }
    });

    linePlans.set(line.dataset.cartItemKey, planMap);
  }

  return linePlans;
}

function intersection(linePlans) {
  const planSets = [...linePlans.values()].map((plans) => new Set(plans.keys()));
  if (!planSets.length) return new Set(BUNDLE_FREQUENCIES);

  const available = BUNDLE_FREQUENCIES.slice(1).filter((label) =>
    planSets.every((plans) => plans.has(label))
  );

  return new Set(['One time', ...available]);
}

async function renderBundleGroup(group) {
  injectBundleSummaryStyles();

  const listRoot = group.closest('[data-bundle-lines-root]');
  if (!listRoot) return;

  const eligibleLines = [...listRoot.children].filter(
    (node) => node !== group && node.hasAttribute('data-bundle-line')
  );

  if (!eligibleLines.length) {
    group.hidden = true;
    return;
  }

  group.hidden = false;
  const itemsTarget = group.querySelector('[data-bundle-group-items]');
  const summaryTarget = summaryTargetForGroup(group, itemsTarget);
  const countTarget = group.querySelector('[data-bundle-count]');
  const tierTarget = group.querySelector('[data-bundle-tier-summary]');
  const messageTarget = group.querySelector('[data-bundle-message]');
  const frequencySelect = group.querySelector('[data-bundle-frequency-select]');
  const config = parseBundleConfig(group);
  const counts = getCounts(eligibleLines);

  eligibleLines.forEach((line) => {
    itemsTarget.appendChild(line);
    line.hidden = true;
    line.style.display = 'none';
  });
  itemsTarget.hidden = true;
  itemsTarget.style.display = 'none';
  summaryTarget.innerHTML = summaryMarkupForLines(eligibleLines);
  countTarget.textContent = `${counts.total} item${counts.total === 1 ? '' : 's'}`;
  tierTarget.innerHTML = tierSummary(counts.total, config.tiers || []);

  const linePlans = await buildLineSellingPlans(eligibleLines);
  const frequencyOptions = intersection(linePlans);
  const activeFrequency = currentFrequency(eligibleLines);
  const selectedFrequency =
    activeFrequency && frequencyOptions.has(activeFrequency) ? activeFrequency : 'One time';

  frequencySelect.innerHTML = BUNDLE_FREQUENCIES
    .map(
      (label) =>
        `<option value="${label}" ${label === selectedFrequency ? 'selected' : ''} ${
          frequencyOptions.has(label) ? '' : 'disabled'
        }>${label}</option>`
    )
    .join('');

  const editButton = group.querySelector('[data-bundle-edit]');
  if (editButton) {
    editButton.onclick = (event) => {
      event.preventDefault();
      openBundleEditor(eligibleLines, selectedFrequency);
    };
  }

  const foodBelowMinimum = counts.food > 0 && counts.food < Number(config.foodMinimum || 4);
  if (foodBelowMinimum) {
    messageTarget.textContent = `Add at least ${config.foodMinimum} food pouches to check out with food in the order.`;
    messageTarget.className = 'bundle-cart-card__message is-error';
  } else {
    const highestTier = [...(config.tiers || [])]
      .sort((left, right) => left.threshold - right.threshold)
      .reduce((current, tier) => (counts.total >= tier.threshold ? tier : current), null);

    if (highestTier) {
      messageTarget.textContent = `${highestTier.discount}% off is active.`;
    } else {
      const itemsNeeded = 8 - counts.total;
      messageTarget.textContent =
        itemsNeeded > 0
          ? `Add ${itemsNeeded} more eligible item${itemsNeeded === 1 ? '' : 's'} to unlock 5% off.`
          : 'Eligible discounts will apply automatically at checkout.';
    }

    messageTarget.className = 'bundle-cart-card__message';
  }

  frequencySelect.onchange = async (event) => {
    const nextFrequency = event.target.value;
    frequencySelect.disabled = true;

    try {
      let finalResponse = null;
      for (let index = 0; index < eligibleLines.length; index += 1) {
        const line = eligibleLines[index];
        const quantityInput = line.querySelector('input[name="updates[]"]');
        const payload = {
          line: Number(line.dataset.lineIndex),
          quantity: Number(quantityInput?.value || line.dataset.lineQuantity || 1),
          selling_plan:
            nextFrequency === 'One time'
              ? null
              : linePlans.get(line.dataset.cartItemKey)?.get(nextFrequency) || null,
        };

        if (index === eligibleLines.length - 1) {
          payload.sections = CART_SECTIONS;
          payload.sections_url = window.location.pathname;
        }

        const response = await fetch(theme.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        });

        finalResponse = await response.json();
      }

      if (finalResponse?.sections) {
        document.body.dispatchEvent(
          new CustomEvent('shapes:modalcart:cartqtychange', {
            bubbles: true,
            detail: { response: finalResponse },
          })
        );
      } else {
        window.location.reload();
      }
    } catch (error) {
      messageTarget.textContent = 'Unable to update the bundle subscription setting.';
      messageTarget.className = 'bundle-cart-card__message is-error';
    } finally {
      frequencySelect.disabled = false;
    }
  };
}

async function clearBundleGroup(group) {
  const items = [...group.querySelectorAll('[data-cart-item-key]')];
  if (!items.length) return;

  const updates = items.reduce((nextUpdates, item) => {
    nextUpdates[item.dataset.cartItemKey] = 0;
    return nextUpdates;
  }, {});

  const clearButton = group.querySelector('[data-bundle-clear]');
  if (clearButton) clearButton.disabled = true;

  try {
    const response = await fetch(theme.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates,
        sections: CART_SECTIONS,
        sections_url: window.location.pathname,
      }),
    });

    const data = await response.json();
    if (Number(data?.item_count || 0) === 0) {
      window.location.href = theme.routes.cart_url;
      return;
    }

    if (data?.sections) {
      document.body.dispatchEvent(
        new CustomEvent('shapes:modalcart:cartqtychange', {
          bubbles: true,
          detail: { response: data },
        })
      );
    } else {
      window.location.reload();
    }
  } catch (error) {
    window.location.reload();
  } finally {
    if (clearButton) clearButton.disabled = false;
  }
}

function initializeBundleGroups(root = document) {
  root.querySelectorAll('[data-bundle-group]').forEach((group) => {
    renderBundleGroup(group);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener(
    'click',
    (event) => {
      const editButton = event.target.closest('[data-bundle-edit]');
      if (!editButton) return;

      const lines = bundleLinesForEditButton(editButton);
      if (!lines.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openBundleEditor(lines, currentFrequency(lines));
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const clearButton = event.target.closest('[data-bundle-clear]');
      if (!clearButton) return;

      const group = clearButton.closest('[data-bundle-group]');
      if (!group) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      clearBundleGroup(group);
    },
    true
  );

  initializeBundleGroups();
});

document.body?.addEventListener('shapes:modalcart:afteradditem', () => {
  window.setTimeout(() => initializeBundleGroups(), 0);
});
document.body?.addEventListener('shapes:modalcart:cartqtychange', () => {
  window.setTimeout(() => initializeBundleGroups(), 0);
});
